import { createSelector } from 'reselect'
import { createCommunicationSelectors } from 'src/helpers/redux'
import { IState, PREFIX, TGlobalStateWithService } from './state'
import { actions } from './actions'

export const selectCommunication = (
  state: TGlobalStateWithService
): IState['communication'] => state[PREFIX].communication

export const communications = createCommunicationSelectors<
  TGlobalStateWithService,
  IState['communication'],
  typeof actions
>(selectCommunication, actions)

export const selectData = (state: TGlobalStateWithService): IState['data'] =>
  state[PREFIX]?.data

export const selectors = {
  numbers: createSelector(selectData, (state) => state.accounts),

  accountItem: createSelector(selectData, (state) => state.accounts.item),

  availableNumbersTwillio: createSelector(
    selectData,
    (state) => state.availableNumbers
  ),
  availableNumbersRc: createSelector(
    selectData,
    (state) => state.availableRcNumbers
  ),
  getCurrentParams: createSelector(
    selectData,
    (state) => state.accounts.params
  ),
}
